<script setup lang="ts">
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { useToast } from "@/components/ui/toast/use-toast"
import { MoreHorizontal, Copy, Pencil, Star, Trash } from "lucide-vue-next"
import type { Row } from "@tanstack/vue-table"
import type { Product } from "./columns"
import { useModalStore } from '@/store/modal'
const modal = useModalStore()
const props = defineProps<{
  row: Row<Product>
}>()

const { toast } = useToast()
const product = props.row.original

function onCopy(id: number) {
  navigator.clipboard.writeText(id.toString())
  toast({
    title: "ID товара скопирован",
    description: `ID товара ${id} скопирован в буфер обмена`,
    variant: "default",
  })
}

function onEdit(product: Product) {
  console.log('product', product)
  modal.openModal('CreateUpdateProductModal', {
    product,
  }).then((response) => {
    if (response) {
      toast({
        title: "Успешно",
        description: "Продукт обновлен",
        variant: "default",
      })
    }
  }).catch((error) => {
    console.log('Product edit cancelled', error)
  })
}

function onDelete(id: number) {
  toast({
    title: "Удаление товара",
    description: `Удаление товара с ID ${id}`,
    variant: "default",
  })
}

function onToggleActive(id: number, isActive: boolean) {
  toast({
    title: "Удаление товара",
    description: `Удаление товара с ID ${id}`,
    variant: "default",
  })
}

</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" class="h-8 w-8 p-0">
        <span class="sr-only">Открыть меню</span>
        <MoreHorizontal class="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem @click="onCopy(product.id)">
        <Copy class="mr-2 h-4 w-4" />
        <span>Копировать ID</span>
      </DropdownMenuItem>
      <DropdownMenuItem @click="onEdit(product)">
        <Pencil class="mr-2 h-4 w-4" />
        <span>Редактировать</span>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem class="text-red-600" @click="onDelete(product.id)">
        <Trash class="mr-2 h-4 w-4" />
        <span>Удалить</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>